module.exports = __webpack_public_path__ + "static/media/Work-Sans-regular.fe3e8d85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Work-Sans-regular/Work-Sans-regular.svg
// module id = 422
// module chunks = 0